var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13565_8373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 13H4V43H49V13Z",
    fill: "#ADCCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13H49L26.5 28L4 13Z",
    fill: "#E1EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 43V13L4 43H49Z",
    fill: "#166DD7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13565_8373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2958 27.7889C33.4654 27.2691 36.7076 27 40.0055 27C43.3031 27 46.545 27.2691 49.7143 27.7888C52.4002 28.2292 54.2602 30.853 54.2602 33.7999V42.9142C54.2602 45.8612 52.4001 48.4849 49.7143 48.9254C43.1961 49.9942 36.7889 49.9901 30.2958 48.9252C27.61 48.4847 25.75 45.861 25.75 42.9141V33.8001C25.75 30.8532 27.61 28.2294 30.2958 27.7889Z",
    fill: "#1150AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0274 30.417C41.5922 30.417 42.8607 31.6855 42.8607 33.2503V34.667H44.6316C45.2184 34.667 45.6941 35.1427 45.6941 35.7295V43.5212C45.6941 44.108 45.2184 44.5837 44.6316 44.5837H35.4232C34.8364 44.5837 34.3607 44.108 34.3607 43.5212V35.7295C34.3607 35.1427 34.8364 34.667 35.4232 34.667H37.1941V33.2503C37.1941 31.6855 38.4626 30.417 40.0274 30.417ZM40.0275 38.5628C39.4407 38.5628 38.965 39.0385 38.965 39.6253C38.965 40.2121 39.4407 40.6878 40.0275 40.6878C40.6143 40.6878 41.09 40.2121 41.09 39.6253C41.09 39.0385 40.6143 38.5628 40.0275 38.5628ZM40.0274 31.8337C39.245 31.8337 38.6107 32.4679 38.6107 33.2503V34.667H41.4441V33.2503C41.4441 32.4679 40.8098 31.8337 40.0274 31.8337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13565_8373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 30,
    fill: "white",
    transform: "translate(4 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13565_8373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white",
    transform: "translate(24.75 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailLock);
export default __webpack_public_path__ + "static/media/icon-email-lock.f78738b9708843f9440ba84d559fe7ab.svg";
export { ForwardRef as ReactComponent };